<div class="bolt-container bolt-space-bottom-2xl">
  <bolt-progress-bar appFocusOnInit arialabel="remove refund method progress value is 100%" class="progress-bar-container to-container" value="100"></bolt-progress-bar>
  <h1 class="bolt-heading-primary bolt-space-bottom-2xl">Remove refund method: confirmation</h1>

  <div class="main-container">
    @if (!apiCallSuccessful) {
      <bolt-notification type="error">
        <span class="error-notification">{{ apiServiceDownMessage }}</span>
      </bolt-notification>
    }
    @else {
      <div class="bolt-space-bottom-2xl">
        <bolt-notification type="success">
          <span class="success-notification">Your request has been processed.</span>
        </bolt-notification>
      </div>
      <app-payment-sub-header>Confirmation details</app-payment-sub-header>
      <div class="main-contents">
        <p><span class="font-weight-bold">Removed refund method: </span>{{confirmationMessage}}</p>
      </div>
    }
  </div>
</div>
<bolt-button-bar>
  <is-button id="print-button" slot="cancel" (click)="showPrintDialog()">Print</is-button>
  <is-button id="continue-button" slot="forward" (click)="onContinue()">
    Payment preferences
  </is-button>
</bolt-button-bar>